export default __webpack_public_path__ + "static/media/dhurina-app.9990117d.apk";